import {attr, controller, target} from '@github/catalyst'
import {currencyFormatter, getUnitData} from './utils'
import type {UnitData} from './utils'

@controller('pro-calculator')
export class ProCalculatorElement extends HTMLElement {
  @target declare subtotalElement: HTMLElement
  @attr costPerMonth = 0
  @attr active = false

  declare unit_data: UnitData

  connectedCallback() {
    this.unit_data = getUnitData()
    this.displayCostPerMonth()
  }

  displayCostPerMonth() {
    this.subtotalElement.textContent = currencyFormatter.format(this.costPerMonth / 100)
  }

  toggleActive() {
    this.active = !this.active
    this.costPerMonth = this.active ? this.unit_data.gh_pro!.value : 0
  }

  getSummaryForCSV() {
    return [
      [
        'GitHub Pro',
        'Individual Plan',
        'Advanced tools for private repositories',
        `"${currencyFormatter.format(this.costPerMonth / 100)}"`,
      ],
    ]
  }

  static observedAttributes = ['data-cost-per-month', 'data-active']
  attributeChangedCallback(name: string, oldValue: string | null, newValue: string | null): void {
    if (oldValue === newValue) return

    if (name === 'data-active') {
      this.costPerMonth = this.active ? this.unit_data.gh_pro!.value : 0
    }

    if (name === 'data-cost-per-month') {
      this.displayCostPerMonth()
      document.dispatchEvent(
        new CustomEvent('subtotalChanged', {
          detail: {sectionName: 'proTotal', amount: this.costPerMonth, active: this.active},
        }),
      )
    }
  }
}
